<template>
  <div class="page-product-specifications-blocks">
    <!-- Categoria  -->
    <div
      class="page-product-specifications-blocks-block"
      v-if="props.product?.relatedCategories?.length"
    >
      <h3 class="text-m">{{ $t('pages.product.specRelatedCategories') }}</h3>
      <ul class="text-s m-top-8px">
        <li
          v-for="(category, index) in props.product.relatedCategories"
          :key="category.id"
        >
          <NuxtLink
            :to="
              localePath({
                name: 'category-slug',
                params: { slug: category.slug },
              })
            "
            class="link-underline-1"
          >
            {{ category.title
            }}<span
              v-if="
                props.product.relatedCategories.length > 0 &&
                index < props.product.relatedCategories.length - 1
              "
              >,</span
            >
          </NuxtLink>
        </li>
        <li v-if="props.product.isSystem">
          <NuxtLink
            :to="localePath({ name: 'typology-systems' })"
            class="link-underline-1"
          >
            <span> {{ $t('pages.product.system') }}</span>
          </NuxtLink>
        </li>
      </ul>
    </div>

    <!-- Materiale  -->
    <div
      class="page-product-specifications-blocks-block"
      v-if="props.product?.productMaterial"
    >
      <h3 class="text-m">{{ $t('pages.product.specProductMaterial') }}</h3>
      <div
        class="text-s m-top-8px"
        v-html="props.product.productMaterial"
      ></div>
    </div>

    <!-- Certification  -->
    <div
      class="page-product-specifications-blocks-block"
      v-if="props.product?.productCertifications?.length"
    >
      <h3 class="text-m">
        {{ $t('pages.product.specProductCertifications') }}
      </h3>
      <ul class="text-s m-top-8px">
        <li
          v-for="(certification, index) in props.product.productCertifications"
          :key="index"
        >
          <template v-if="certification.toLowerCase() === 'ce'">
            <img
              src="~/assets/img/ico/ico-ce-dark.svg"
              alt="Ico CE"
              width="23"
              height="16"
              class="--ico-ce"
            />
          </template>
          <template v-else-if="certification.toLowerCase() === 'ul'">
            <img
              src="~/assets/img/ico/ico-ul-dark.svg"
              alt="Ico CE"
              width="16"
              height="16"
              class="--ico-ul"
            />
          </template>
          <template v-else>
            {{ certification }}
          </template>
        </li>
      </ul>
    </div>

    <!-- Designer  -->
    <div
      class="page-product-specifications-blocks-block"
      v-if="props.product?.designer?.length"
    >
      <h3 class="text-m">{{ $t('pages.product.specDesigner') }}</h3>

      <ul class="text-s m-top-8px">
        <li
          v-for="(designer, index) in props.product.designer"
          :key="designer.id"
        >
          <NuxtLink
            class="link-underline-1"
            :to="
              localePath({
                name: 'designers-slug',
                params: {
                  slug: designer.slug,
                },
              })
            "
            >{{ designer.title
            }}<span
              v-if="
                props.product.designer.length > 0 &&
                index < props.product.designer.length - 1
              "
              >,</span
            ></NuxtLink
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesProductSpecificationsBlock',
}
</script>

<script setup>
const props = defineProps({
  product: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
